import React, { useState } from 'react';
import { Sprout, Copy } from 'lucide-react';

import { sortedPhotos } from '../../utils/photos';
import { cloudinaryScaled, cloudinaryScaledSrcSet, cloudinaryThumb, cloudinaryThumbSrcSet } from '../../utils/cloudinary';

// Simple, dependency-free gallery: a main image + thumbnail strip.
// Falls back to a branded placeholder when a product has no photos.
export default function ProductGallery({ photos, title, onCopyLink }) {
  const images = sortedPhotos(photos);
  const [active, setActive] = useState(0);

  const copyBtn = onCopyLink && (
    <button
      type="button"
      className="ss-product-card__copy-btn"
      onClick={onCopyLink}
      aria-label="Copy product link"
      title="Copy product link"
    >
      <Copy size={16} aria-hidden="true" />
    </button>
  );

  if (images.length === 0) {
    return (
      <div className="ss-gallery__main">
        {copyBtn}
        <span className="ss-media-empty">
          <Sprout size={72} aria-hidden="true" />
        </span>
      </div>
    );
  }

  const current = images[Math.min(active, images.length - 1)];

  return (
    <div>
      <div className="ss-gallery__main">
        {copyBtn}
        <img
          src={cloudinaryScaled(current.url, 800)}
          srcSet={cloudinaryScaledSrcSet(current.url, [400, 800, 1200])}
          sizes="(max-width: 760px) 100vw, 580px"
          alt={title}
        />
      </div>
      {images.length > 1 && (
        <div className="ss-gallery__thumbs">
          {images.map((p, i) => (
            <button
              key={p.publicId || i}
              type="button"
              className={`ss-gallery__thumb ${i === active ? 'is-active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`View image ${i + 1} of ${images.length}`}
              aria-pressed={i === active}
            >
              <img src={cloudinaryThumb(p.url, 100)} srcSet={cloudinaryThumbSrcSet(p.url, 100)} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
